module.exports = __webpack_public_path__ + "img/2.195923c2.png";